import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'

import jobsTable from '../../site/plugins/tchibo-jobs/assets/jobs_table.js'
import jobPage from '../../site/plugins/tchibo-jobs/assets/job_page.js'
Alpine.plugin(jobsTable)
Alpine.plugin(jobPage)

Alpine.plugin(collapse)

window.Alpine = Alpine
Alpine.start()

function getContrastYIQ(hexColor) {
    const r = parseInt(hexColor.substr(1, 2), 16);
    const g = parseInt(hexColor.substr(3, 2), 16);
    const b = parseInt(hexColor.substr(5, 2), 16);
    const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
    return (yiq >= 160) ? 'black' : 'white';
}

function setBadgeTextColor() {
    const badges = document.querySelectorAll('.damo-flag');
    badges.forEach(badge => {
        const bgColor = getComputedStyle(badge).backgroundColor;
        const bgColorHex = rgbToHex(bgColor);
        const textColor = getContrastYIQ(bgColorHex);
        badge.style.color = textColor;
    });
}

function rgbToHex(rgb) {
    const regex = /^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/;
    const match = rgb.match(regex);
    if (!match) {
        return null;
    }
    const r = parseInt(match[1]);
    const g = parseInt(match[2]);
    const b = parseInt(match[3]);
    return '#' + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
}

document.addEventListener('DOMContentLoaded', setBadgeTextColor);
